import { SERVER_URL } from '../config/api';

export type StateData = {
    name: string;
    abbreviation: string;
    councils: string[];
};

export type BusinessType = {
    name: string;
    sortOrder: number;
};

const BASE = `${SERVER_URL}/api/public/reference-data`;

export const referenceDataApi = {
    getStates: async (): Promise<StateData[]> => {
        const response = await fetch(`${BASE}/states`, {
            method: 'GET',
            headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Failed to fetch states');
        return response.json();
    },

    getCouncilsForState: async (abbreviation: string): Promise<{ state: string; stateName: string; councils: string[] }> => {
        const response = await fetch(`${BASE}/states/${abbreviation}/councils`, {
            method: 'GET',
            headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`Failed to fetch councils for ${abbreviation}`);
        return response.json();
    },

    getBusinessTypes: async (): Promise<BusinessType[]> => {
        const response = await fetch(`${BASE}/business-types`, {
            method: 'GET',
            headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Failed to fetch business types');
        return response.json();
    },
};
